import { render, staticRenderFns } from "./unit.vue?vue&type=template&id=00c8b4d4&scoped=true"
import script from "./unit.vue?vue&type=script&lang=js"
export * from "./unit.vue?vue&type=script&lang=js"
import style0 from "./unit.vue?vue&type=style&index=0&id=00c8b4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c8b4d4",
  null
  
)

export default component.exports